import Vue from "vue";
import Router from "vue-router";
import NProgress from "nprogress";
import store from "@/store/store";

// Containers
const DefaultContainer = () => import("@/containers/DefaultContainer");

// Views
const Dashboard = () => import("@/views/Dashboard");

const Colors = () => import("@/views/theme/Colors");
const Typography = () => import("@/views/theme/Typography");

const Charts = () => import("@/views/Charts");
const Widgets = () => import("@/views/Widgets");

// Views - Components
const Cards = () => import("@/views/base/Cards");
const Forms = () => import("@/views/base/Forms");
const Switches = () => import("@/views/base/Switches");
const Tables = () => import("@/views/base/Tables");
const Tabs = () => import("@/views/base/Tabs");
const Breadcrumbs = () => import("@/views/base/Breadcrumbs");
const Carousels = () => import("@/views/base/Carousels");
const Collapses = () => import("@/views/base/Collapses");
const Jumbotrons = () => import("@/views/base/Jumbotrons");
const ListGroups = () => import("@/views/base/ListGroups");
const Navs = () => import("@/views/base/Navs");
const Navbars = () => import("@/views/base/Navbars");
const Paginations = () => import("@/views/base/Paginations");
const Popovers = () => import("@/views/base/Popovers");
const ProgressBars = () => import("@/views/base/ProgressBars");
const Tooltips = () => import("@/views/base/Tooltips");

// Views - Buttons
const StandardButtons = () => import("@/views/buttons/StandardButtons");
const ButtonGroups = () => import("@/views/buttons/ButtonGroups");
const Dropdowns = () => import("@/views/buttons/Dropdowns");
const BrandButtons = () => import("@/views/buttons/BrandButtons");

// Views - Icons
const Flags = () => import("@/views/icons/Flags");
const FontAwesome = () => import("@/views/icons/FontAwesome");
const SimpleLineIcons = () => import("@/views/icons/SimpleLineIcons");
const CoreUIIcons = () => import("@/views/icons/CoreUIIcons");

// Views - Notifications
const Alerts = () => import("@/views/notifications/Alerts");
const Badges = () => import("@/views/notifications/Badges");
const Modals = () => import("@/views/notifications/Modals");

// Views - Pages
const Page404 = () => import("@/views/pages/Page404");
const Page500 = () => import("@/views/pages/Page500");
const Login = () => import("@/views/pages/Login");
const Register = () => import("@/views/pages/Register");

// Views - test
const EventList = () => import("@/views/test/EventList");

const MyUserList = () => import("@/views/myUsers/MyUserList");
const UserProfile = () => import("@/views/myUsers/UserProfile");

const OrderList = () => import("@/views/orders/OneTimeOrderList");
const OneTimeOrder = () => import("@/views/orders/OneTimeOrder");
const ExpeditedRequest = () => import("@/views/orders/ExpeditedRequest");

const ProductionCalendar = () => import("@/views/dashboard/ProductionCalendar");

const MCapMonthList = () => import("@/views/mcaps/MonthList");
const MCapOrderList = () => import("@/views/mcaps/MCapOrderList");
const MCapOrderView = () => import("@/views/mcaps/MCapOrderView");

const ShippingMonthList = () => import("@/views/shipping/ShippingMonthList");
const ShippingOrder = () => import("@/views/shipping/ShippingOrder");
const ShippingScan = () => import("@/views/shipping/ShippingScan");

const ShippingReports = () => import("@/views/shipping/DeliveryList");
const MailTrackerContainer = () =>
  import("@/views/shipping/MailTrackerContainer");
//const Dealership = () => import("@/views/dealerships/DealershipProfile")

//const CampaignList = () => import("@/views/campaigns/CampaignList")
//const Campaign = () => import("@/views/campaigns/CampaignEdit")

// Users
const Users = () => import("@/views/users/Users");
const User = () => import("@/views/users/User");
// Clients
//const ClientList = () => import("@/views/clients/ClientList")
//const ClientProfile = () => import("@/views/clients/ClientProfile")

Vue.use(Router);

const router = new Router({
  mode: "hash", // https://router.vuejs.org/api/#mode
  linkActiveClass: "open active",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "/",
      redirect: "/dashboard",
      name: "Home",
      component: DefaultContainer,
      children: [
        {
          path: "dashboard",
          name: "Dashboard",
          component: Dashboard
        },
        {
          path: "theme",
          redirect: "/theme/colors",
          name: "Theme",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "colors",
              name: "Colors",
              component: Colors
            },
            {
              path: "typography",
              name: "Typography",
              component: Typography
            }
          ]
        },
        {
          path: "charts",
          name: "Charts",
          component: Charts
        },
        {
          path: "widgets",
          name: "Widgets",
          component: Widgets
        },
        {
          path: "users",
          meta: { label: "Users" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: MyUserList
              //component: Users
            },
            {
              path: "edit",
              meta: { label: "User Details" },
              name: "User",
              component: UserProfile
            }
          ]
        },
        {
          path: "orders",
          meta: { label: "Orders" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: OrderList
              //component: Users
            },
            {
              path: "edit",
              meta: { label: "Order Details" },
              name: "OneTimeOrder",
              component: OneTimeOrder
            }
          ]
        },
        {
          path: "production",
          meta: { label: "Production" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: ShippingMonthList
            },
            {
              path: "Shipment",
              meta: { label: "Shipment Details" },
              name: "ShippingOrder",
              component: ShippingOrder
            }
          ]
        },
        {
          path: "scanning",
          meta: { label: "Ticket Scan" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: ShippingScan
            }
          ]
        },
        {
          path: "shipping",
          meta: { label: "Shipping" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: ShippingReports
            } //,
            // {
            //   path: "Shipment",
            //   meta: { label: "Shipment Details" },
            //   name: "ShippingOrder",
            //   component: ShippingOrder
            // }
          ]
        },
        {
          path: "mailtrack",
          meta: { label: "Mail Tracker" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: MailTrackerContainer
            } //,
            // {
            //   path: "Shipment",
            //   meta: { label: "Shipment Details" },
            //   name: "ShippingOrder",
            //   component: ShippingOrder
            // }
          ]
        },
        {
          path: "calendar",
          meta: { label: "Calendar" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: ProductionCalendar
            } //,
            // {
            //   path: "Shipment",
            //   meta: { label: "Shipment Details" },
            //   name: "ShippingOrder",
            //   component: ShippingOrder
            // }
          ]
        },
        {
          path: "client-direct",
          meta: { label: "ClientDirect" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: MCapMonthList
              //component: Users
            },
            {
              path: "orders",
              meta: { label: "Orders" },
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "",
                  name: "ClientDirectOrders",
                  component: MCapOrderList
                },
                {
                  path: "view",
                  meta: { label: "View" },
                  name: "ClientDirectOrder",
                  component: MCapOrderView
                }
              ]
            }
          ]
        },

        {
          path: "expedite",
          meta: { label: "Expedite" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: ExpeditedRequest
            }
          ]
        },
        {
          path: "login",
          meta: { label: "Login" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: Login
              //component: Users
            }
          ]
        },
        {
          path: "base",
          redirect: "/base/cards",
          name: "Base",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "cards",
              name: "Cards",
              component: Cards
            },
            {
              path: "forms",
              name: "Forms",
              component: Forms
            },
            {
              path: "switches",
              name: "Switches",
              component: Switches
            },
            {
              path: "tables",
              name: "Tables",
              component: Tables
            },
            {
              path: "tabs",
              name: "Tabs",
              component: Tabs
            },
            {
              path: "breadcrumbs",
              name: "Breadcrumbs",
              component: Breadcrumbs
            },
            {
              path: "carousels",
              name: "Carousels",
              component: Carousels
            },
            {
              path: "collapses",
              name: "Collapses",
              component: Collapses
            },
            {
              path: "jumbotrons",
              name: "Jumbotrons",
              component: Jumbotrons
            },
            {
              path: "list-groups",
              name: "List Groups",
              component: ListGroups
            },
            {
              path: "navs",
              name: "Navs",
              component: Navs
            },
            {
              path: "navbars",
              name: "Navbars",
              component: Navbars
            },
            {
              path: "paginations",
              name: "Paginations",
              component: Paginations
            },
            {
              path: "popovers",
              name: "Popovers",
              component: Popovers
            },
            {
              path: "progress-bars",
              name: "Progress Bars",
              component: ProgressBars
            },
            {
              path: "tooltips",
              name: "Tooltips",
              component: Tooltips
            }
          ]
        },
        {
          path: "buttons",
          redirect: "/buttons/standard-buttons",
          name: "Buttons",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "standard-buttons",
              name: "Standard Buttons",
              component: StandardButtons
            },
            {
              path: "button-groups",
              name: "Button Groups",
              component: ButtonGroups
            },
            {
              path: "dropdowns",
              name: "Dropdowns",
              component: Dropdowns
            },
            {
              path: "brand-buttons",
              name: "Brand Buttons",
              component: BrandButtons
            }
          ]
        },
        {
          path: "icons",
          redirect: "/icons/font-awesome",
          name: "Icons",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "coreui-icons",
              name: "CoreUI Icons",
              component: CoreUIIcons
            },
            {
              path: "flags",
              name: "Flags",
              component: Flags
            },
            {
              path: "font-awesome",
              name: "Font Awesome",
              component: FontAwesome
            },
            {
              path: "simple-line-icons",
              name: "Simple Line Icons",
              component: SimpleLineIcons
            }
          ]
        },
        {
          path: "notifications",
          redirect: "/notifications/alerts",
          name: "Notifications",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "alerts",
              name: "Alerts",
              component: Alerts
            },
            {
              path: "badges",
              name: "Badges",
              component: Badges
            },
            {
              path: "modals",
              name: "Modals",
              component: Modals
            }
          ]
        }
      ]
    },
    {
      path: "/pages",
      redirect: "/pages/404",
      name: "Pages",
      component: {
        render(c) {
          return c("router-view");
        }
      },
      children: [
        {
          path: "404",
          name: "Page404",
          component: Page404
        },
        {
          path: "500",
          name: "Page500",
          component: Page500
        },
        {
          path: "register",
          name: "Register",
          component: Register
        },
        {
          path: "test",
          name: "MyUserList",
          component: MyUserList
        },
        {
          path: "UserProfile",
          name: "UserProfile",
          component: UserProfile
        }
      ]
    }
  ]
});

router.beforeEach((routeTo, routeFrom, next) => {
  if (store.state.n_user.n_current_user_has_access) {
    NProgress.start();
    next();
  } else {
    if (routeTo.path != "/login") {
      next({ path: "/login" });
    } else {
      NProgress.start();
      next();
    }
  }
});

router.afterEach((routeTo, routeFrom) => {
  NProgress.done();
});

export default router;
